//// src/pages/CreateEventPage.tsx
//import React, { useState, useEffect, Suspense, useRef } from 'react';
//import { useNavigate } from 'react-router-dom';
//import { Formik, Form, Field, ErrorMessage, FormikHelpers } from 'formik';
//import * as Yup from 'yup';
//import api from '../services/api';
//import { useTranslation } from 'react-i18next';
//import { useNotification } from '../context/NotificationContext';
//import { type Team } from '../types';
//import { useAuth } from '../context/AuthContext';

//// --- Reusable Form Components (bez zmian) ---
//const FormInput = ({ name, type = 'text', label, ...props }: any) => (
//    <div>
//        <label htmlFor={name} className="block text-sm font-medium text-gray-300">{label}</label>
//        <Field
//            id={name} name={name} type={type}
//            className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
//            {...props}
//        />
//        <ErrorMessage name={name} component="p" className="text-red-400 text-xs italic mt-1" />
//    </div>
//);

//const FormSelect = ({ name, label, children }: any) => (
//    <div>
//        <label htmlFor={name} className="block text-sm font-medium text-gray-300">{label}</label>
//        <Field as="select" id={name} name={name}
//            className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500">
//            {children}
//        </Field>
//        <ErrorMessage name={name} component="p" className="text-red-400 text-xs italic mt-1" />
//    </div>
//);

//const FormTextArea = ({ name, label, ...props }: any) => (
//    <div>
//        <label htmlFor={name} className="block text-sm font-medium text-gray-300">{label}</label>
//        <Field as="textarea" id={name} name={name}
//            className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
//            {...props}
//        />
//        <ErrorMessage name={name} component="p" className="text-red-400 text-xs italic mt-1" />
//    </div>
//);

//// --- Główny komponent strony ---
//const CreateEventPageContent: React.FC = () => {
//    const navigate = useNavigate();
//    const { t } = useTranslation();
//    const { showNotification } = useNotification();

//    const initialValues = {
//        eventName: '',
//        teamAName: '',
//        teamBName: '',
//        sportType: 'Football',
//        startTime: '',
//        status: 'Scheduled',
//        numberOfParts: 2,
//        rosterA_starters: '',
//        rosterA_subs: '',
//        rosterB_starters: '',
//        rosterB_subs: '',
//    };

//    const validationSchema = Yup.object({
//        eventName: Yup.string().required(t('validation.required')),
//        teamAName: Yup.string().required(t('validation.required')),
//        teamBName: Yup.string()
//            .required(t('validation.required'))
//            .test('teams-different', t('createEvent.validation.teamsCannotBeTheSame'), function (value) {
//                const { teamAName } = this.parent as { teamAName?: string };
//                if (!value || !teamAName) return true;
//                return value.trim().toLowerCase() !== teamAName.trim().toLowerCase();
//            }),
//        sportType: Yup.string().required(t('validation.required')),
//        startTime: Yup.date().required(t('validation.required')),
//        numberOfParts: Yup.number().min(1).max(10).required(t('validation.required')),
//    });

//    const { user } = useAuth();
//    const [teams, setTeams] = useState<Team[]>([]);

//    useEffect(() => {
//        if (user) {
//            api.get(`/Teams/user/${user.nameid}`)
//                .then(response => setTeams(response.data))
//                .catch(error => console.error("Błąd podczas pobierania drużyn:", error));
//        }
//    }, [user]);

//    const handleSubmit = async (values: typeof initialValues, { setSubmitting }: FormikHelpers<typeof initialValues>) => {
//        const parseRoster = (rosterText: string) => rosterText
//            .split('\n')
//            .filter(name => name.trim() !== '')
//            .map(name => ({ name: name.trim(), isCaptain: false }));

//        const eventData = {
//            eventName: values.eventName,
//            teamAName: values.teamAName,
//            teamBName: values.teamBName,
//            sportType: values.sportType,
//            startTime: values.startTime,
//            status: values.status,
//            numberOfParts: values.numberOfParts,
//            rosterA: { starters: parseRoster(values.rosterA_starters), substitutes: parseRoster(values.rosterA_subs) },
//            rosterB: { starters: parseRoster(values.rosterB_starters), substitutes: parseRoster(values.rosterB_subs) },
//        };

//        try {
//            await api.post('/Events', eventData);
//            showNotification(t('createEvent.successMessage'), 'success');
//            navigate('/events');
//        } catch (error: any) {
//            const errorMessage = error.response?.data?.title || error.response?.data || t('createEvent.errorMessage');
//            showNotification(errorMessage, 'error');
//            setSubmitting(false);
//        }
//    };

//    return (
//        <div className="max-w-4xl mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
//            <h1 className="text-3xl font-bold text-white text-center mb-8">{t('createEvent.pageTitle')}</h1>
//            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
//                {({ isSubmitting, values }) => (
//                    <Form className="space-y-6">
//                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                            <FormInput name="eventName" label={t('createEvent.eventNameLabel')} />
//                            <FormInput name="startTime" type="datetime-local" label={t('createEvent.startTimeLabel')} />
//                        </div>
//                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                            <FormInput name="teamAName" label={t('createEvent.teamALabel')} />
//                            <FormInput name="teamBName" label={t('createEvent.teamBLabel')} />
//                            <FormSelect name="sportType" label={t('createEvent.sportTypeLabel')}>
//                                <option value="Football">{t('sportTypes.Football')}</option>
//                                <option value="Basketball">{t('sportTypes.Basketball')}</option>
//                                <option value="Volleyball">{t('sportTypes.Volleyball')}</option>
//                            </FormSelect>
//                        </div>

//                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                            <FormInput name="numberOfParts" type="number" label={t('createEvent.partsLabel')} />
//                            <div />
//                        </div>

//                        <hr className="border-gray-700 my-4" />

//                        <div className="text-center">
//                            <h3 className="text-xl font-semibold text-white">{t('createEvent.rostersOptional')}</h3>
//                            <p className="text-sm text-gray-400">{t('createEvent.rostersHelpText')}</p>
//                        </div>

//                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//                            <div className="space-y-4">
//                                <h4 className="text-lg font-bold text-center text-white">{values.teamAName || t('common.teamA')}</h4>
//                                <FormTextArea name="rosterA_starters" label={t('createEvent.starters')} rows={6} />
//                                <FormTextArea name="rosterA_subs" label={t('createEvent.substitutes')} rows={4} />
//                            </div>
//                            <div className="space-y-4">
//                                <h4 className="text-lg font-bold text-center text-white">{values.teamBName || t('common.teamB')}</h4>
//                                <FormTextArea name="rosterB_starters" label={t('createEvent.starters')} rows={6} />
//                                <FormTextArea name="rosterB_subs" label={t('createEvent.substitutes')} rows={4} />
//                            </div>
//                        </div>

//                        <div className="pt-4">
//                            <button
//                                type="submit"
//                                disabled={isSubmitting}
//                                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
//                            >
//                                {isSubmitting ? t('common.loading') : t('createEvent.submitButton')}
//                            </button>
//                        </div>
//                    </Form>
//                )}
//            </Formik>
//        </div>
//    );
//};

//const CreateEventPage = () => (
//    <Suspense fallback={<div className="text-center p-8 text-white">Ładowanie...</div>}>
//        <CreateEventPageContent />
//    </Suspense>
//);

//export default CreateEventPage;


// src/pages/CreateEventPage.tsx
import React, { useState, useEffect, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import api from '../services/api';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../context/NotificationContext';
import { type Team } from '../types';
import { useAuth } from '../context/AuthContext';

// --- Reusable Form Components ---
const FormInput = ({ name, type = 'text', label, ...props }: any) => (
    <div>
        <label htmlFor={name} className="block text-sm font-medium text-gray-300">{label}</label>
        <Field
            id={name} name={name} type={type}
            className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            {...props}
        />
        <ErrorMessage name={name} component="p" className="text-red-400 text-xs italic mt-1" />
    </div>
);

const FormSelect = ({ name, label, children }: any) => (
    <div>
        <label htmlFor={name} className="block text-sm font-medium text-gray-300">{label}</label>
        <Field
            as="select" id={name} name={name}
            className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
        >
            {children}
        </Field>
        <ErrorMessage name={name} component="p" className="text-red-400 text-xs italic mt-1" />
    </div>
);

const FormTextArea = ({ name, label, ...props }: any) => (
    <div>
        <label htmlFor={name} className="block text-sm font-medium text-gray-300">{label}</label>
        <Field
            as="textarea" id={name} name={name}
            className="mt-1 block w-full bg-gray-700 border border-gray-600 rounded-md shadow-sm py-2 px-3 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            {...props}
        />
        <ErrorMessage name={name} component="p" className="text-red-400 text-xs italic mt-1" />
    </div>
);

// --- Główny komponent strony ---
const CreateEventPageContent: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { showNotification } = useNotification();
    const { user } = useAuth();

    const initialValues = {
        eventName: '',
        teamAName: '',
        teamBName: '',
        sportType: 'Football',
        startTime: '',
        status: 'Scheduled',
        numberOfParts: 2,
        rosterA_starters: '',
        rosterA_subs: '',
        rosterB_starters: '',
        rosterB_subs: '',
    };

    const validationSchema = Yup.object({
        eventName: Yup.string().required(t('validation.required')),
        teamAName: Yup.string().required(t('validation.required')),
        teamBName: Yup.string()
            .required(t('validation.required'))
            .test('teams-different', t('createEvent.validation.teamsCannotBeTheSame'), function (value) {
                const { teamAName } = this.parent as { teamAName?: string };
                if (!value || !teamAName) return true;
                return value.trim().toLowerCase() !== teamAName.trim().toLowerCase();
            }),
        sportType: Yup.string().required(t('validation.required')),
        startTime: Yup.date().required(t('validation.required')),
        numberOfParts: Yup.number().min(1).max(10).required(t('validation.required')),
    });

    const [teams, setTeams] = useState<Team[]>([]);

    useEffect(() => {
        if (user) {
            api.get(`/Teams/user/${user.nameid}`)
                .then((response) => setTeams(response.data))
                .catch((error) => console.error('Błąd podczas pobierania drużyn:', error));
        }
    }, [user]);

    // --- helpers: normalizacja i ensure ---
    const normalize = (s: string) =>
        (s || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();

    // w niektórych wersjach modelu Team pole to "discipline" zamiast "sportType"
    const getTeamDiscipline = (team: Team) => {
        const anyTeam = team as unknown as { sportType?: string; discipline?: string };
        return normalize(anyTeam.sportType ?? anyTeam.discipline ?? '');
    };

    const findTeam = (name: string, sportType: string, list: Team[]) => {
        const nName = normalize(name);
        const nSport = normalize(sportType);
        return list.find(
            (t) => normalize(t.name) === nName && getTeamDiscipline(t) === nSport
        );
    };

    const ensureTeamExists = async (name: string, sportType: string) => {
        if (!name?.trim()) return;

        // odśwież listę (na wypadek równoległych zmian)
        let current = teams;
        try {
            if (user) {
                const res = await api.get(`/Teams/user/${user.nameid}`);
                current = res.data;
                setTeams(res.data);
            }
        } catch {
            // jeśli się nie uda – skorzystamy z lokalnego cache
        }

        if (findTeam(name, sportType, current)) return;

        // utwórz brakującą drużynę; wyślij oba pola: discipline i sportType
        try {
            const payload = { name: name.trim(), sportType, discipline: sportType };
            const res = await api.post('/Teams', payload);
            setTeams((prev) => [...prev, res.data]);
        } catch (err) {
            console.warn('Nie udało się utworzyć drużyny (może już istnieje?):', err);
        }
    };

    const handleSubmit = async (
        values: typeof initialValues,
        { setSubmitting }: FormikHelpers<typeof initialValues>
    ) => {
        const parseRoster = (rosterText: string) =>
            rosterText
                .split('\n')
                .map((s) => s.trim())
                .filter((name) => name !== '')
                .map((name) => ({ name, isCaptain: false }));

        // Upewnij się, że drużyny istnieją (po nazwie + dyscyplinie)
        try {
            await Promise.all([
                ensureTeamExists(values.teamAName, values.sportType),
                ensureTeamExists(values.teamBName, values.sportType),
            ]);
        } catch (e) {
            console.error('Błąd ensureTeamExists:', e);
        }

        const eventData = {
            eventName: values.eventName,
            teamAName: values.teamAName,
            teamBName: values.teamBName,
            sportType: values.sportType,
            startTime: values.startTime,
            status: values.status,
            numberOfParts: values.numberOfParts,
            rosterA: { starters: parseRoster(values.rosterA_starters), substitutes: parseRoster(values.rosterA_subs) },
            rosterB: { starters: parseRoster(values.rosterB_starters), substitutes: parseRoster(values.rosterB_subs) },
        };

        try {
            await api.post('/Events', eventData);
            showNotification(t('createEvent.successMessage'), 'success');
            navigate('/events');
        } catch (error: any) {
            const errorMessage = error.response?.data?.title || error.response?.data || t('createEvent.errorMessage');
            showNotification(errorMessage, 'error');
            setSubmitting(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
            <h1 className="text-3xl font-bold text-white text-center mb-8">{t('createEvent.pageTitle')}</h1>
            <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                {({ isSubmitting, values }) => (
                    <Form className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormInput name="eventName" label={t('createEvent.eventNameLabel')} />
                            <FormInput name="startTime" type="datetime-local" label={t('createEvent.startTimeLabel')} />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <FormInput name="teamAName" label={t('createEvent.teamALabel')} />
                            <FormInput name="teamBName" label={t('createEvent.teamBLabel')} />
                            <FormSelect name="sportType" label={t('createEvent.sportTypeLabel')}>
                                <option value="Football">{t('sportTypes.Football')}</option>
                                <option value="Basketball">{t('sportTypes.Basketball')}</option>
                                <option value="Volleyball">{t('sportTypes.Volleyball')}</option>
                            </FormSelect>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <FormInput name="numberOfParts" type="number" label={t('createEvent.partsLabel')} />
                            <div />
                        </div>

                        <hr className="border-gray-700 my-4" />

                        <div className="text-center">
                            <h3 className="text-xl font-semibold text-white">{t('createEvent.rostersOptional')}</h3>
                            <p className="text-sm text-gray-400">{t('createEvent.rostersHelpText')}</p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div className="space-y-4">
                                <h4 className="text-lg font-bold text-center text-white">{values.teamAName || t('common.teamA')}</h4>
                                <FormTextArea name="rosterA_starters" label={t('createEvent.starters')} rows={6} />
                                <FormTextArea name="rosterA_subs" label={t('createEvent.substitutes')} rows={4} />
                            </div>
                            <div className="space-y-4">
                                <h4 className="text-lg font-bold text-center text-white">{values.teamBName || t('common.teamB')}</h4>
                                <FormTextArea name="rosterB_starters" label={t('createEvent.starters')} rows={6} />
                                <FormTextArea name="rosterB_subs" label={t('createEvent.substitutes')} rows={4} />
                            </div>
                        </div>

                        <div className="pt-4">
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                            >
                                {isSubmitting ? t('common.loading') : t('createEvent.submitButton')}
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

const CreateEventPage = () => (
    <Suspense fallback={<div className="text-center p-8 text-white">Ładowanie...</div>}>
        <CreateEventPageContent />
    </Suspense>
);

export default CreateEventPage;
